module.exports = "/images/icon_social_yt_yellow.png?c66cc672ce4d793d76fc3951e3a7d695";